import React from "react";
// ---------------- SessionWarningModal ----------------
interface ModalProps {
  isVisible: boolean;
  countdown?: number;
}

export const SessionWarningModal: React.FC<ModalProps> = ({ isVisible,countdown }) => {
  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded shadow-md text-center max-w-sm">
        <h2 className="text-lg font-bold mb-2">Session Expiring Soon</h2>
        <p className="mb-4">Your session will expire in {countdown} seconds.</p>
      </div>
    </div>
  );
};